import request from '../request';
import { API_URL } from '../../utils/constants';
import { IntegrationEditDto } from '~/src/types/integrations/IntegrationEditDto';
import { IntegrationCredentialEditDto } from '~/src/types/integrations/IntegrationCredentialEditDto';

const integrationsBaseUrl = `${API_URL}/integrations`;

export default {
  getById: async (id: string) => {
    return request(`${integrationsBaseUrl}/${id}`, 'get');
  },

  create: async (values: IntegrationEditDto) => {
    const body = JSON.stringify(values);
    return request(`${integrationsBaseUrl}/create`, 'post', body);
  },

  update: async (id: string, values: IntegrationEditDto) => {
    const body = JSON.stringify(values);
    return request(`${integrationsBaseUrl}/update/${id}`, 'put', body);
  },

  delete: async (id: string) => {
    return request(`${integrationsBaseUrl}/delete/${id}`, 'delete');
  },

  getSchema: async (type: number) => {
    return request(`${integrationsBaseUrl}/schema/${type}`, 'get');
  },

  activate: async (integrationCredential: IntegrationCredentialEditDto, integrationType: number) => {
    const body = JSON.stringify(integrationCredential);
    return request(`${integrationsBaseUrl}/activate/${integrationType}`, 'post', body);
  },

  getActiveIntegrations: async () => {
    return request(`${integrationsBaseUrl}/get-active-integrations`, 'get');
  }
}